function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgMateriaisDeConstrucao = function SvgMateriaisDeConstrucao(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3H5.143a.857.857 0 00-.857.857v3.429c0 .473.383.857.857.857H12a.857.857 0 00.857-.857V3.857A.857.857 0 0012 3zM5.143 7.286V3.858H12v3.428H5.143z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.714 7.286H.857A.857.857 0 000 8.143v3.428c0 .474.384.858.857.858h6.857a.857.857 0 00.857-.858V8.143a.857.857 0 00-.857-.857zM.857 11.572V8.143h6.857v3.429H.857zM7.714 15.857H.857a.857.857 0 00-.857.857v3.429c0 .473.384.857.857.857h6.857a.857.857 0 00.857-.857v-3.429a.857.857 0 00-.857-.857zM.857 20.143v-3.428h6.857v3.428H.857z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.571 7.286h6.858a.86.86 0 01.201.024c.614.148.43.833-.201.833H8.57v3.429h2.858v.857H8.57a.857.857 0 01-.857-.858V8.143c0-.474.384-.857.857-.857z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.714 12a.429.429 0 00-.428-.429H5.143a.857.857 0 00-.857.858v3.428c0 .474.383.857.857.857h6.286v-.856H5.143v-3.429h8.143a.429.429 0 00.428-.429z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.286a.429.429 0 00-.429-.429h-3a.857.857 0 00-.857.857v3.429c0 .473.384.857.857.857h6.858a.857.857 0 00.857-.857v-1.286a.429.429 0 10-.857 0v1.286H8.57v-3.428h3a.429.429 0 00.429-.43z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.857 18.428a.429.429 0 00-.428.43v1.285c0 .473.383.857.857.857h6.857a.857.857 0 00.857-.857v-3.429a.857.857 0 00-.857-.857h-1a.429.429 0 000 .858h1v3.428h-6.857v-1.286a.429.429 0 00-.429-.428z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.906 3.44a1.61 1.61 0 012.125 2.415l-.006.006-2.863 2.596c-.16.142-.346.248-.545.316l1.167 1.347a.876.876 0 01-.069 1.211l-.564.565.696.696a1.574 1.574 0 01-.543 2.689l-6.293 2.445c-.143.056-.48.141-.74-.119-.259-.259-.174-.596-.118-.738l2.446-6.296a1.579 1.579 0 012.686-.542l1.158 1.158.506-.506-1.994-2.3a1.68 1.68 0 01-.064-.069l-.001-.001a1.61 1.61 0 01.146-2.268l2.852-2.59a.548.548 0 01.018-.015zm-2.223 4.256l-.027-.032a.492.492 0 00-.037-.038.61.61 0 01.08-.832l2.851-2.59a.61.61 0 01.8.92L19.5 7.708a.61.61 0 01-.816-.013zm-1.395 2.828a.58.58 0 00-.752.399l-2.174 5.594 5.595-2.174a.572.572 0 00.23-.999.5.5 0 01-.033-.03l-2.588-2.589a.504.504 0 01-.027-.03.579.579 0 00-.252-.17z",
    fill: props.color
  }));
};
SvgMateriaisDeConstrucao.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgMateriaisDeConstrucao.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgMateriaisDeConstrucao;